module.exports = __webpack_public_path__ + "static/media/time_log_on@2x.0eea3d8e.svg";